
export class BaseModel {
  public Id: number;
}
